import { API } from "../constants/api";
import { axiosPostWithToken, axiosGetWithToken } from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";
import { CHANGE_VIEW_PROJECT_TAB } from "./viewProjectTabAction";
import axios from "axios";

export const GET_WORKFLOW_ASSIGNMENT = "GET_WORKFLOW_ASSIGNMENT";
export const WORKFLOW_ASSIGNMENT_LOADING = "WORKFLOW_ASSIGNMENT_LOADING";
export const SET_WORKFLOW_ASSIGNMENT_ITEMS_PER_PAGE =
  "SET_WORKFLOW_ASSIGNMENT_ITEMS_PER_PAGE";
export const CHANGE_CURRENT_WORKFLOW_ASSIGNMENT_PAGE =
  "CHANGE_CURRENT_WORKFLOW_ASSIGNMENT_PAGE";
export const SEARCH_WORKFLOW_ASSIGNMENT = "SEARCH_WORKFLOW_ASSIGNMENT";
export const FILTER_WORKFLOW_ASSIGNMENT_ROLES =
  "FILTER_WORKFLOW_ASSIGNMENT_ROLES";
export const FILTER_WORKFLOW_ASSIGNMENT_SKILLS =
  "FILTER_WORKFLOW_ASSIGNMENT_SKILLS";
export const WORKFLOW_ASSIGNMENT_MIN_REL_EXP =
  "WORKFLOW_ASSIGNMENT_MIN_REL_EXP";
export const WORKFLOW_ASSIGNMENT_MAX_REL_EXP =
  "WORKFLOW_ASSIGNMENT_MAX_REL_EXP";
export const WORKFLOW_ASSIGNMENT_FILTER_REL_EXP =
  "WORKFLOW_ASSIGNMENT_FILTER_REL_EXP";
export const WORKFLOW_ASSIGNMENT_SET_TABLE_SELECTED_ROWS =
  "WORKFLOW_ASSIGNMENT_SET_TABLE_SELECTED_ROWS";
export const RESET_WORKFLOW_ASSIGNMENT = "RESET_WORKFLOW_ASSIGNMENT";
export const FILTER_WORKFLOW_ASSIGNMENT_STATUS =
  "FILTER_WORKFLOW_ASSIGNMENT_STATUS";
export const WORKFLOW_ASSIGNMENT_SET_HASDONE_FILTER =
  "WORKFLOW_ASSIGNMENT_SET_HASDONE_FILTER";
export const WORKFLOW_ASSIGNMENT_SET_MATCHING_FILTER =
  "WORKFLOW_ASSIGNMENT_SET_MATCHING_FILTER";
export const WORKFLOW_ASSIGNMENT_MIN_TOTAL_EXP =
  "WORKFLOW_ASSIGNMENT_MIN_TOTAL_EXP";
export const WORKFLOW_ASSIGNMENT_MAX_TOTAL_EXP =
  "WORKFLOW_ASSIGNMENT_MAX_TOTAL_EXP";
export const WORKFLOW_ASSIGNMENT_FILTER_TOTAL_EXP =
  "WORKFLOW_ASSIGNMENT_FILTER_TOTAL_EXP";

export const WORKFLOW_ASSIGNMENT_VIEW_FUNCTIONAL_FEEDBACK =
  "WORKFLOW_ASSIGNMENT_VIEW_FUNCTIONAL_FEEDBACK";
export const WORKFLOW_ASSIGNMENT_VIEW_ASSIGNMENT_FEEDBACK =
  "WORKFLOW_ASSIGNMENT_VIEW_ASSIGNMENT_FEEDBACK";

export const FILTER_WORKFLOW_ASSIGNMENT_AVAILABLE_HOURS =
  "FILTER_WORKFLOW_ASSIGNMENT_AVAILABLE_HOURS";

export const VIEW_WORKFLOW_ASSIGMENT_TIMELINE =
  "VIEW_WORKFLOW_ASSIGMENT_TIMELINE";

export const FILTER_WORKFLOW_ASSIGNMENT_FLEXIBEES_SELECTED =
  "FILTER_WORKFLOW_ASSIGNMENT_FLEXIBEES_SELECTED";

export const FILTER_WORKFLOW_ASSIGNMENT_ACTIVE_PROJECTS =
  "FILTER_WORKFLOW_ASSIGNMENT_ACTIVE_PROJECTS";

export const getCandidateTimeline = (id, toggleModal) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    axiosGetWithToken(`${API.GET_CANDIDATE_TIMELINE}/${id}/`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          // console.log("res.", res.data);
          dispatch({
            type: VIEW_WORKFLOW_ASSIGMENT_TIMELINE,
            payload: res.data.data,
          });
          toggleModal();
        } else {
          toggleModal('error');
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || res.data.data.detail || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        toggleModal('error');
        dispatch({
          type: ERROR_ALERT,
          payload:
            (err && err.response && err.response.data) ||
            "Something went wrong.",
        });
      });
  };
};

export const downloadCandidateTimeline = (id, endLoader) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    var config = {
      headers: { Authorization: token, "Content-Type": "application/pdf" },
      responseType: "blob",
    };

    axios
      .get(`${API.DOWNLOAD_CANDIDATE_TIMELINE}/${id}/`, config)
      .then((response) => {
        console.log(response.data);
        let url = window.URL.createObjectURL(response.data);
        window.open(url);
        if (endLoader) {
          endLoader();
        }
      });
  };
};
export const getAssignment = (projectId, closeModal) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const pagesize =
      getstate().workflowAssignment.workflowAssignmentResultsPerPage;
    const page = getstate().workflowAssignment.workflowAssignmentCurrentPage;
    const seachText =
      getstate().workflowAssignment.workflowAssignmentSearchText;
    const roles =
      getstate().workflowAssignment.workflowAssignmentAppliedRolesFilter;
    const skills =
      getstate().workflowAssignment.workflowAssignmentAppliedSkillsFilter;
    const status =
      getstate().workflowAssignment.workflowAssignmentAppliedStatusFilter;
    const minRelExp =
      getstate().workflowAssignment.workflowAssignmentAppliedMinRelExpFilter;
    const maxRelExp =
      getstate().workflowAssignment.workflowAssignmentAppliedMaxRelExpFilter;
    const minTotalExp =
      getstate().workflowAssignment.workflowAssignmentAppliedMinTotalExpFilter;
    const maxTotalExp =
      getstate().workflowAssignment.workflowAssignmentAppliedMaxTotalExpFilter;
    const matching =
      getstate().workflowAssignment.workflowAssignmentAppliedMatchingFilter ===
      "0"
        ? false
        : true;
    const total_available_hours =
      getstate().workflowAssignment.workflowAssignmentAppliedAvailableHoursFilter;
    const flexibees_selected =
      getstate().workflowAssignment.candidatesListApplaiedFilterFlexiSelected;
    const active_projects =
      getstate().workflowAssignment.candidatesListApplaiedFilterActiveProjects;

    const body = {
      search_term: seachText,
      filter_data: {
        roles: roles,
        skills: skills,
        status: status,
        functional: matching,
        flexibees_selected: flexibees_selected,
        active_projects: active_projects,
        relevant_experience: {
          min: minRelExp,
          max: maxRelExp,
        },
        years_of_experience: {
          min: minTotalExp,
          max: maxTotalExp,
        },
        total_available_hours: total_available_hours,
      },
    };

    axiosPostWithToken(
      `${API.GET_WORKFLOW_ASSIGNMENT}/${projectId}/${pagesize}/${page}/`,
      body,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: GET_WORKFLOW_ASSIGNMENT,
          payload: res.data.data,
        });
        if (closeModal) {
          closeModal();
        }
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (res.data && res.data.data && res.data.data.message) ||
            "Something went wrong. Unable to fetch data.",
        });
      }
    });
  };
};

export const resetTableData = () => {
  return async (dispatch) => {
    dispatch({
      type: CHANGE_VIEW_PROJECT_TAB,
      payload: 0,
    });
    dispatch({
      type: RESET_WORKFLOW_ASSIGNMENT,
    });
  };
};

export const sendAssignmentNotification = (body, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosPostWithToken(`${API.SEND_ASSIGNMENT_NOTIFICATION}`, body, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          refresh();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              (res.data && res.data.data && res.data.data.message) ||
              "Something went wrong. Unable to process request.",
          });
        }
      }
    );
  };
};

export const setItemsPerPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: SET_WORKFLOW_ASSIGNMENT_ITEMS_PER_PAGE,
      payload: value,
    });
  };
};

export const changeCurrentPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: CHANGE_CURRENT_WORKFLOW_ASSIGNMENT_PAGE,
      payload: value,
    });
  };
};

export const search = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: SEARCH_WORKFLOW_ASSIGNMENT,
      payload: value,
    });
  };
};

export const filterRoles = (roles) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: FILTER_WORKFLOW_ASSIGNMENT_ROLES,
      payload: roles,
    });
  };
};

export const filterSkills = (skills) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: FILTER_WORKFLOW_ASSIGNMENT_SKILLS,
      payload: skills,
    });
  };
};

export const filterStatus = (status) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: FILTER_WORKFLOW_ASSIGNMENT_STATUS,
      payload: status,
    });
  };
};

export const filterAvailableHours = (hours) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: FILTER_WORKFLOW_ASSIGNMENT_AVAILABLE_HOURS,
      payload: hours,
    });
  };
};

export const changeMinRelExp = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_MIN_REL_EXP,
      payload: value,
    });
  };
};

export const changeMaxRelExp = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_MAX_REL_EXP,
      payload: value,
    });
  };
};

export const clearRelExpFilter = (value, filterData) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: WORKFLOW_ASSIGNMENT_MIN_REL_EXP,
      payload: value,
    });
    dispatch({
      type: WORKFLOW_ASSIGNMENT_MAX_REL_EXP,
      payload: value,
    });
    dispatch({
      type: WORKFLOW_ASSIGNMENT_FILTER_REL_EXP,
      payload: false,
    });
    filterData();
  };
};

export const filterRelExp = (filterData) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: WORKFLOW_ASSIGNMENT_FILTER_REL_EXP,
      payload: true,
    });
    filterData();
  };
};

export const changeMinTotalExp = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_MIN_TOTAL_EXP,
      payload: value,
    });
  };
};

export const changeMaxTotalExp = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_MAX_TOTAL_EXP,
      payload: value,
    });
  };
};

export const clearTotalExpFilter = (value, filterData) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: WORKFLOW_ASSIGNMENT_MIN_TOTAL_EXP,
      payload: value,
    });
    dispatch({
      type: WORKFLOW_ASSIGNMENT_MAX_TOTAL_EXP,
      payload: value,
    });
    dispatch({
      type: WORKFLOW_ASSIGNMENT_FILTER_TOTAL_EXP,
      payload: false,
    });
    filterData();
  };
};

export const filterTotalExp = (filterData) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: WORKFLOW_ASSIGNMENT_FILTER_TOTAL_EXP,
      payload: true,
    });
    filterData();
  };
};

export const setTableRows = (rows) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_SET_TABLE_SELECTED_ROWS,
      payload: rows,
    });
  };
};

export const setHasDoneFilter = (data) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_SET_HASDONE_FILTER,
      payload: data,
    });
  };
};

export const setMatchingFilter = (data) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_ASSIGNMENT_LOADING,
    });
    dispatch({
      type: WORKFLOW_ASSIGNMENT_SET_MATCHING_FILTER,
      payload: data,
    });
  };
};

export const getFunctionalFeedback = (functional_id, toggleModal) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosGetWithToken(
      `${API.VIEW_FUNCTIONAL_FEEDBACK}/${functional_id}/`,
      token
    ).then((res) => {
      console.log("view", res.data.data);
      if (res.data.status_code === 200) {
        dispatch({
          type: WORKFLOW_ASSIGNMENT_VIEW_FUNCTIONAL_FEEDBACK,
          payload: res.data.data,
        });
        toggleModal("ViewFunctionalFeedback");
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong. Unable to fetch data.",
        });
        console.log(`Error: ${res.data.data.message}`);
      }
    });
  };
};

export const getAssignmentFeedback = (id, toggleModal) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosGetWithToken(`${API.VIEW_ASSIGNMENT_FEEDBACK}/${id}/`, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: WORKFLOW_ASSIGNMENT_VIEW_ASSIGNMENT_FEEDBACK,
            payload: res.data.data,
          });
          toggleModal("ViewAssignmentFeedback");
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: "Something went wrong. Unable to fetch data.",
          });
          console.log(`Error: ${res.data.data.message}`);
        }
      }
    );
  };
};

export const updateAssignmentFeedback = (body, assignment_id, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosPostWithToken(
      `${API.UPDATE_ASSIGNMENT_FEEDBACK}/${assignment_id}/`,
      body,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        refresh();
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Updated Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (res.data && res.data.data && res.data.data.message) ||
            "Something went wrong. Unable to process request.",
        });
      }
    });
  };
};

export const moveToNextLevel = (body, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosPostWithToken(`${API.MOVE_TO_NEXT_LEVEL}`, body, token).then((res) => {
      if (res.data.status_code === 200) {
        refresh();
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Candidate moved to Functional Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (res.data && res.data.data && res.data.data.message) ||
            "Something went wrong. Unable to process request.",
        });
      }
    });
  };
};

export const scheduleFunctionalInterview = (
  assignment_id,
  data,
  successDialog
) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosPostWithToken(
      `${API.SCHEDULE_FUNCTIONAL_INTERVIEW}/${assignment_id}/`,
      data,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        successDialog();
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (res.data && res.data.data && res.data.data.message) ||
            "Something went wrong. Unable to process request.",
        });
      }
    });
  };
};

export const setFlexibeesSelectedFilter = (value) => {
  return async (dispatch) => {
    dispatch({
      type: FILTER_WORKFLOW_ASSIGNMENT_FLEXIBEES_SELECTED,
      payload: value,
    });
  };
};

export const setActiveProjectsFilter = (value) => {
  return async (dispatch) => {
    dispatch({
      type: FILTER_WORKFLOW_ASSIGNMENT_ACTIVE_PROJECTS,
      payload: value,
    });
  };
};
